<template>
  <div class="cookies"
       v-if="!agreed || wordingsEditable">
    <div class="cookies__text">
      <p v-word:layout.cookieConsent.message></p>
    </div>
    <div class="cookies__buttons">
      <button type="button"
              v-word:layout.cookieConsent.button
              @click.prevent="onAgreedClick"></button>
    </div>
  </div>
</template>

<script>
const localStorageItemName = 'sso-reg-cookies-agreed';
import * as mixins from '../mixins';

export default {
  mixins: [mixins.wordedPage],
  data() {
    return {
      agreed: !!localStorage.getItem(localStorageItemName),
    };
  },
  methods: {
    onAgreedClick() {
      if (this.wordingsEditable) {
        return;
      }

      localStorage.setItem(localStorageItemName, new Date().getTime());
      this.agreed = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layout/CookieCompliance.vue